import React from 'react';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
function Footer(props) {
    const navigate = useNavigate('');
    const navHome = () => {
        navigate('/')
    }
    const navProdutos = () => {
        navigate('/produtos')
    }
    const navAssTec = () => {
        navigate('/assistencia-tecnica')
    }
    const navComercial = () => {
        navigate('/comercial')
    }
    const navBalancas = () => {
        navigate('/balancas-cuiaba')
    }

    return(
    <div className="footer-container">
        <div className="footer-content">
            <div className="footer-1">
                <img src='/images/logobc.svg' className='footer-logobc from-left'/>
                <div className='footer-parceiros'>
                    <h4 className='footer-1-title from-right'>PARCEIROS</h4>
                    <a href='https://www.weightech.com.br/' target='_blank' className='footer-parceiros-link from-right'>
                    <img src='/images/logos/logoweightech.svg' className='footer-logoweightech'/></a>
                    <a href='https://www.mt.com/br/pt/home.html/' target='_blank' className='footer-parceiros-link from-right'>
                    <img src='/images/logos/logomettlertoledo.svg' className='footer-logomettlertoledo'/></a>
                </div>
            </div>
            <div className="footer-2">
                <div className="footer-info1 from-bottom">
                    <h3 className='footer-info-title'>BALANÇAS CUIABÁ</h3>
                    <a className="footer2-title" href='/'>Início</a>
                    <a className="footer2-title" href='/produtos'>Produtos</a>
                    <a className="footer2-title" href='/balancas-cuiaba'>Balanças Cuiabá</a>
                    <a className="footer2-title" href='/assistencia-tecnica'>Assistência Técnica</a>
                    <a className="footer2-title" href='/comercial'>Comercial</a>
                    <a className="footer2-title" href='/produtos/pesagem-rodoviaria'>Pesagem Rodoviária</a>
                </div>
                <div className="footer-info2 from-bottom">
                    <h3 className='footer-info-title'>DIVISÃO INDUSTRIAL</h3>
                    <h4 className='footer-text'>Rua Pedro Luiz Boaretto<br/>Núc. Prod. Ind II, n. 145<br/>Bairro Cataratas - Cascavel PR</h4>

                    <h3 className='footer-info-title'>DIVISÃO ASSIST. TÉCNICA</h3>
                    <h4 className='footer-text'>Rua Goncalo Crisostomo<br/>do Prado, n. 35<br/>Bairro Centro-Sul - Várzea Grande MT</h4>
                    {/* <a href='https://maps.app.goo.gl/o9fCZotQHdmuGv4n9'><Button sx={{fontFamily:'Inter', height:'50px', borderRadius:'8px', color:'#fff', textTransform:'none', backgroundColor:'transparent', fontWeight:'500', fontSize:'16px','&:hover':{backgroundColor:'#c4c4c4'}}}><img className='footer-mapIcon' src='/images/icons/geo-alt.svg'/> Ver no Google Maps</Button></a> */}
                    
                </div>
                <div className="footer-info3 from-bottom">
                    <h3 className='footer-info-title'>HORÁRIO DE ATENDIMENTO</h3>
                    <h4 className='footer-text'>De segunda à sexta-feira<br/>08:00 as 17:48<br/>Aos sábados não atendemos</h4>
                </div>
                <div className="footer-info4 from-bottom">
                    <h3 className='footer-info-title'>FALE CONOSCO</h3>
                    <h4 className='footer-text'>(45) 3225-6467</h4>
                    <h4 className='footer-text'>(45) 3306-7028</h4>
                    <h4 className='footer-text'>atendimento.cascavel@balancascuiaba.com.br</h4>
                    <a href="https://wa.me/+556599547518"><Button sx={{fontFamily:'Inter', height:'50px', borderRadius:'8px', color:'#fff', textTransform:'none', backgroundColor:'transparent', fontWeight:'500', fontSize:'16px','&:hover':{backgroundColor:'#c4c4c4'}}}><img className='footer-comercialIcon' src='/images/icons/atendimento.svg'/> Fale com um vendedor</Button></a>
                </div>
            </div>
            <div className="footer-line"/>
            <div className='footerBar'>
                <div className="rights">© 2026 - Balanças Cuiabá - Todos os direitos reservados.</div>
                <div className='dev'>
                    Desenvolvido por:
                    <a className="developer" href='https://sigmasystems.com.br'><div style={{display:'flex'}}><img src="https://odontoluzzi.com.br/images/logoSigma.svg" className="logoSigma" alt="sigmaLogo"></img></div></a>
                </div>
            </div>
        </div>
    </div>
    )
};
export default Footer;